import {
    Box,
    Card,
    CardContent,
    Checkbox,
    FormControl,
    FormControlLabel,
    Grid, IconButton,
    Input,
    InputAdornment, MenuItem, Menu, Typography
} from "@deere/fuel-react";
import React, {useEffect, useState} from "react";
import {Controller} from "react-hook-form";
import MoreVert from "@material-ui/icons/MoreVert";
import {makeStyles} from '@material-ui/core/styles';
import {Loading} from "../shared/Loading";

const useStyles = makeStyles(() => ({
    list: {
        padding: '0.5rem !important',
    },
}));

export const RatingPgmCriteriaList = ({control, currentCriteria, onUpdateCriteria}) => {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(true);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [criteriaObj, setCriteriaObj] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleSelectedCriteria = (selected, event) => {
        if (!event.target.checked) {
            onUpdateCriteria(criteriaObj.id, false, 0, event.target.checked)
        } else {
            onUpdateCriteria(criteriaObj.id, criteriaObj.isRequired, criteriaObj.weight, event.target.checked)
        }
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleWeightChange = (value) => {
        onUpdateCriteria(criteriaObj.id, criteriaObj.isRequired, value, criteriaObj.isSelected)
    };

    const handleRequiredCriteria = () => {
        onUpdateCriteria(criteriaObj.id, true, criteriaObj.weight, criteriaObj.isSelected)
        setAnchorEl(null);
    };

    const handleNotRequiredCriteria = () => {
        onUpdateCriteria(criteriaObj.id, false, criteriaObj.weight, criteriaObj.isSelected)
        setAnchorEl(null);
    };

    useEffect(() => {
        setCriteriaObj(currentCriteria)
        setIsLoading(false);
    }, [currentCriteria])

    return (
        <Grid container key={currentCriteria.id}>
            {isLoading && (
                <>
                    <Loading/>
                </>
            )}
            {!isLoading && (
                <Grid item xs={12}>
                    <Box mb={3}>
                        <Card>
                            <CardContent>
                                <Box
                                    display="flex" flexDirection="column"
                                    alignItems="center">
                                    <Grid container>
                                        <Grid item xs={10}>
                                            <Box display="inline-flex"
                                                 justifyContent="flex-start"
                                                 alignItems="center"
                                                 alignContent="center">
                                                <FormControl
                                                    required
                                                    component="fieldset"
                                                >
                                                    <Controller
                                                        control={control}
                                                        defaultValue={criteriaObj.isSelected}
                                                        value={criteriaObj.isSelected}
                                                        name={`${criteriaObj.id}check`}
                                                        render={({
                                                                     onChange,
                                                                     value
                                                                 }) => (
                                                            <>
                                                                <FormControlLabel
                                                                    style={{marginRight: 0}}
                                                                    control={
                                                                        <Checkbox
                                                                            name={`${criteriaObj.id}checkbox`}
                                                                            checked={value}/>}
                                                                    label={<>
                                                                        <Typography
                                                                            color={criteriaObj.isSelected ? "primary" : "tertiary"}
                                                                            size="md"
                                                                            variant={"body1"}
                                                                            display="inline">
                                                                            {criteriaObj.description}
                                                                        </Typography>
                                                                        {criteriaObj.isRequired ? (
                                                                            <span style={{
                                                                                marginLeft: ".25rem",
                                                                                display: "inline"
                                                                            }}
                                                                                  aria-label="required field"
                                                                                  className="uxf-is-required"
                                                                            > * </span>
                                                                        ) : ""}
                                                                    </>}
                                                                    onChange={(e) => {
                                                                        onChange(e.target.checked);
                                                                        handleSelectedCriteria(criteriaObj.id, e)
                                                                    }}
                                                                />
                                                            </>
                                                        )}
                                                    />
                                                </FormControl>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Box display="flex"
                                                 justifyContent="flex-end"
                                                 ml={9}
                                                 alignItems="center"
                                                 alignContent="center">
                                                <FormControl>
                                                    <Controller
                                                        control={control}
                                                        defaultValue={criteriaObj.weight}
                                                        value={criteriaObj.weight}
                                                        name={`${criteriaObj.id}-crit-weight`}
                                                        render={({
                                                                     onChange,
                                                                     value
                                                                 }) => (
                                                            <Input
                                                                id={`${criteriaObj.id}-crit-weight`}
                                                                disabled={!criteriaObj.isSelected}
                                                                value={value}
                                                                onChange={(e) => {
                                                                    onChange(e.target.value);
                                                                    handleWeightChange(e.target.value);
                                                                }}
                                                                endAdornment={
                                                                    <InputAdornment
                                                                        position="end">%</InputAdornment>}
                                                            />
                                                        )}
                                                    />
                                                    {criteriaObj.isNotValid && (
                                                        <Grid item xs={12}>
                                                            <Box display="flex" justifyContent="flex-end" mb={1}>
                                                                <Typography color="error" size="xs">
                                                                    Criteria weight should be > 0
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                    )}
                                                </FormControl>
                                                <IconButton aria-label="more" onClick={handleClick}
                                                            disabled={!criteriaObj.isSelected}>
                                                    <MoreVert/>
                                                </IconButton>
                                                <Menu
                                                    id="long-menu"
                                                    anchorEl={anchorEl}
                                                    open={open}
                                                    keepMounted
                                                    getContentAnchorEl={null}
                                                    anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'center',
                                                    }}
                                                    onClose={handleClose}
                                                >
                                                    {criteriaObj.isRequired ? (
                                                        <MenuItem
                                                            key={1}
                                                            className={classes.list}
                                                            divider={true}
                                                            onClick={handleNotRequiredCriteria}>
                                                            {"Not Required Question"}
                                                        </MenuItem>
                                                    ) : (
                                                        <MenuItem
                                                            key={1}
                                                            className={classes.list}
                                                            divider={true}
                                                            onClick={handleRequiredCriteria}>
                                                            {"Required Question"}
                                                        </MenuItem>)}
                                                    <MenuItem key={2} className={classes.list} onClick={handleClose}>
                                                        <a href={`/criteria-catalog/edit-criteria/${criteriaObj.id}`}
                                                           target="_blank"
                                                           rel="noopener noreferrer"
                                                           style={{textDecoration: "none"}}>
                                                            <Typography
                                                                color="primary"
                                                                size="sm">{"Edit Criteria"}</Typography></a>
                                                    </MenuItem>
                                                </Menu>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </CardContent>
                        </Card>
                    </Box>
                </Grid>
            )}
        </Grid>
    )
}
